"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authorizationReducer = void 0;

var reducer_1 = require("../loading/reducer");

var actions_1 = require("../transaction/actions");

var actions_2 = require("./actions");

var utils_1 = require("./utils");

var INITIAL_STATE = {
  data: [],
  loading: [],
  error: null
};

function authorizationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions_2.GRANT_TOKEN_REQUEST:
    case actions_2.REVOKE_TOKEN_REQUEST:
    case actions_2.GRANT_TOKEN_SUCCESS:
    case actions_2.REVOKE_TOKEN_SUCCESS:
    case actions_2.FETCH_AUTHORIZATIONS_REQUEST:
      {
        return Object.assign(Object.assign({}, state), {
          loading: reducer_1.loadingReducer(state.loading, action)
        });
      }

    case actions_2.FETCH_AUTHORIZATIONS_SUCCESS:
      {
        var authorizations = action.payload.authorizations;
        return {
          loading: reducer_1.loadingReducer(state.loading, action),
          error: null,
          data: [].concat(_toConsumableArray(state.data), _toConsumableArray(authorizations))
        };
      }

    case actions_2.GRANT_TOKEN_FAILURE:
    case actions_2.REVOKE_TOKEN_FAILURE:
    case actions_2.FETCH_AUTHORIZATIONS_FAILURE:
      {
        return Object.assign(Object.assign({}, state), {
          loading: reducer_1.loadingReducer(state.loading, action),
          error: action.payload.error
        });
      }

    case actions_1.FETCH_TRANSACTION_SUCCESS:
      {
        var transaction = action.payload.transaction;

        switch (transaction.actionType) {
          case actions_2.GRANT_TOKEN_SUCCESS:
            {
              var authorization = transaction.payload.authorization;
              return Object.assign(Object.assign({}, state), {
                data: [].concat(_toConsumableArray(state.data), [Object.assign({}, authorization)])
              });
            }

          case actions_2.REVOKE_TOKEN_SUCCESS:
            {
              var _authorization = transaction.payload.authorization;
              return Object.assign(Object.assign({}, state), {
                data: _toConsumableArray(state.data.filter(function (stateAuthorization) {
                  return !utils_1.areEqual(stateAuthorization, _authorization);
                }))
              });
            }

          default:
            return state;
        }
      }

    default:
      return state;
  }
}

exports.authorizationReducer = authorizationReducer;